import styled from "@emotion/styled";
import { keyframes } from "@emotion/core";

const animateShimmer = keyframes`
   0% {
    background-position: -468px 0;
  }
  
  100% {
    background-position: 468px 0; 
  }
`;

export const Shimmer = styled.div`
    background: #dfe1e6;
    background-image: linear-gradient(to right, #dfe1e6 0%, #f2f4fa 100%);
    background-repeat: no-repeat;
    background-size: 800px 104px;
    display: inline-block;
    position: relative;
    animation: ${animateShimmer} 1s linear forwards infinite;
`;
